module.exports = __webpack_public_path__ + "static/img/strategy-bg-right.4cc5f75a.png";